import { defineComponent as _defineComponent } from 'vue'
type Props = {
    grade: number
    maxStars?: number
    hasCounter?: boolean
}
type Emits = {
    (e: "update:grade", grade: number): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'star-rating',
  props: {
    grade: null,
    maxStars: { default: 5 },
    hasCounter: { type: Boolean, default: true }
  },
  emits: ["update:grade"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "update:grade", grade: number): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as { grade: number, maxStars: number, hasCounter: boolean }






const rate = (star) => {
    // console.log("HERE", star)
    emit('update:grade', star)
}

const __returned__ = { props, emit, rate }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})